import { Input } from "@digipost/dds-input-react";
import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons/faExclamationCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";

import { useTranslate } from "../infrastructure/useTranslate";

type Props = {
  emailOnChange: (email: string) => void;
  phoneOnChange: (phone: string) => void;
  email: string;
  phone: string;
  emailValid: boolean;
  phoneValid: boolean;
};

const ContactForm: FC<Props> = ({
  emailOnChange,
  phoneOnChange,
  email,
  phone,
  emailValid,
  phoneValid,
}) => {
  const translate = useTranslate();
  return (
    <div>
      <Input
        labelText={translate("register.your_email")}
        errorText={
          !emailValid
            ? translate("register.org.registration_form.invalid_email")
            : undefined
        }
        errorIcon={<FontAwesomeIcon icon={faExclamationCircle} />}
        onChange={(event) => {
          emailOnChange(event.target.value);
        }}
        valid={emailValid}
        value={email}
        name="email"
      />

      <Input
        labelText={translate("register.your_phone_number")}
        errorText={
          !phoneValid
            ? translate("register.org.registration_form.invalid_phone")
            : undefined
        }
        errorIcon={<FontAwesomeIcon icon={faExclamationCircle} />}
        onChange={(event) => {
          phoneOnChange(event.target.value);
        }}
        valid={phoneValid}
        value={phone}
        name="phone"
      />
    </div>
  );
};

export default ContactForm;
